<p-card>
    <ng-template #header>
        <div class="card-header" [class.font-bold]="true">
            <div class="flex-1 textSubheader large">{{ title | translate }}</div>
        </div>
    </ng-template>
    <ng-template #content>
        <div class="grid-1col input-grid-gaps">
            @if (!hideUseCardInput) {
                <app-check-input
                    id="useCard"
                    [form]="form"
                    label="service.settings.useCard"
                ></app-check-input>
            }
            @if (!hideCustomCardNameInput) {
                <app-text-input
                    id="customCardName"
                    [form]="form"
                    label="service.settings.customCardName"
                ></app-text-input>
            }
            @if (!hideShareWithOtherServicesInput) {
                <app-multi-select-input
                    id="shareWithOtherServices"
                    [form]="form"
                    label="service.settings.shareWithOtherServices"
                    [staticOptions]="store.services()"
                    [showClear]="true"
                    valueKey="id"
                    display="comma"
                ></app-multi-select-input>
            }

            @if (additionalContentTemplate()) {
                <ng-container [ngTemplateOutlet]="additionalContentTemplate()"></ng-container>
            }
        </div>
    </ng-template>

    <ng-template #footer>
        @if (footerTemplate()) {
            <ng-container [ngTemplateOutlet]="footerTemplate()"></ng-container>
        } @else if (settingsKey) {
            <app-action-buttons
                (primaryClickEvent)="save()"
                (secondaryClickEvent)="setFormValue()"
            ></app-action-buttons>
        }
    </ng-template>
</p-card>
